const PRIMARY_SESSION_TYPES_COLORS = [
    '#04467D',
    '#C23969',
    '#00C98E',
    '#F45B5B',
    '#2B908F',
    '#AD3A02',
    '#F3A712',
    '#9C75D4',
    '#BABABA',
    '#6FBDEC'
];

const PRIMARY_GRAPH_COLORS = [
    '#008DD5',
    '#F99272',
    '#E74545',
    '#5CF0C5',
    '#FBBCA8',
    '#C2A9E6',
    '#F89EB4',
    '#E78614',
    '#F98585',
    '#00679B',
    '#F36614',
    '#6D3BB4',
    '#BA5C94',
    '#03685A',
    '#CD3403',
    '#532793',
    '#8D125B',
    '#F3D69D',
    '#B53048',
    '#7F7F7F',
    '#64646C',
    '#2F2F32',
    '#99AFB1',
    '#4027BB',
    '#B73C65',
    '#3F9542',
    '#8CB85A',
    '#80C783',
    '#A4A4A4',
    '#44D7B6',
    '#8A0101',
    '#999ED5',
    '#99B5D5',
    '#87CBD3',
    '#D3A987',
    '#E6A1A1',
    '#E7C800'
];

export const ETS_RATIO_GRAPH_COLORS = [
    '#1E40AF', // Dark blue
    '#0F172A', // Slate-900
    '#581C87', // Purple-900
    '#134E4A', // Teal-900
    '#831843', // Pink-900
    '#064E3B', // Emerald-900
    '#78350F', // Amber-900
    '#312E81', // Indigo-900
    '#115E59', // Teal-800
    '#9A3412', // Orange-900
    '#6B21A8', // Violet-900
    '#075985', // Sky-800
    '#991B1B', // Red-900
    '#14532D', // Green-900
    '#713F12', // Yellow-900
    '#1E3A8A', // Blue-900
    '#86198F', // Fuchsia-900
    '#365314', // Lime-900
    '#881337', // Rose-900
    '#0C4A6E'  // Sky-900
];

export const SESSION_RESULTS_GRAPH_COLORS = [...PRIMARY_GRAPH_COLORS, ...PRIMARY_SESSION_TYPES_COLORS];

export const SESSION_TYPES_COLORS = [...PRIMARY_SESSION_TYPES_COLORS, ...PRIMARY_GRAPH_COLORS];

export const LUDUM_INJURY_ILLNESS_COLORS = {
    EMPTY: '#bababa',
    INJURY: '#008DD5',
    ILLNESS: '#1B4365',
    BOTH: '#F3A712'
};

export const HR_ZONES_COLORS = ['#cececf', '#aad76a', '#43ba64', '#f3e07a', '#ffa46c', '#fb5d5d'];
